import AOS from "aos";
import "aos/dist/aos.css";

import "bootstrap"; // js
import "./main.scss";
import "./packages.scss";
import navbar from "./components/navbar/navbar.js";

window.onload = function() {
	navbar();
	console.log("here");
	const brandName = document.querySelector(".brand-name");
	const homeItem = document.querySelector(".home-item");

	brandName.addEventListener("click", (e) => {
		const activeElem = document.querySelector(".nav-item.active");

		activeElem.classList.remove("active");
		homeItem.classList.add("active");
	});
	``;
};
